import ApiService from '@/core/services/api.service';
const resource = '/brands';

export default {
  async get(params = {}) {
    try {
      const { page = 1, pageSize = 10, name = '' } = params;
      const response = await ApiService.query(resource, {
        params: { page, pageSize, name },
      });
      return response.data.data;
    } catch (error) {
      console.error(error);
    }
  },

  async getAll() {
    try {
      const response = await ApiService.get(`${resource}/all`);
      return response.data.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async create(payload) {
    try {
      const response = await ApiService.post(resource, payload);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },

  async update(id, data) {
    try {
      const response = await ApiService.put(`${resource}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },

  async delete(id) {
    try {
      const response = await ApiService.delete(`${resource}/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
};
